var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomMeasurements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4515 12.4641C72.3181 12.388 72.1523 12.4843 72.1523 12.6378V18.2887C72.1523 18.3603 72.1905 18.4263 72.2525 18.462L138.501 56.6302C138.634 56.707 138.801 56.6107 138.801 56.4569V50.4458C138.801 50.374 138.762 50.3077 138.7 50.2721L72.4515 12.4641Z",
    fill: "#DB6C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0825 87.5496V58.3114C37.0825 58.2393 37.1212 58.1729 37.1839 58.1374L50.7444 50.4516C50.8777 50.376 51.043 50.4723 51.043 50.6256V79.4838L37.0825 87.5496Z",
    fill: "#DB6C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.443 102.607C21.1065 102.416 21.1049 101.932 21.4401 101.739L73.7326 71.6255C73.9631 71.4928 74.2466 71.492 74.4778 71.6235L126.967 101.485C127.304 101.676 127.304 102.162 126.967 102.354L74.102 132.476L21.443 102.607Z",
    fill: "#E9AF34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1017 138.418V88.1681L11.3584 51.9209V102.362L74.1017 138.418Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1021 138.418V88.1681L136.845 51.9209V102.362L74.1021 138.418Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1017 15.9248V66.1751L11.3584 102.422V51.98L74.1017 15.9248Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 102.362L74.1048 66.1738L11.3618 102.42L74.1048 138.417L136.848 102.362Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 51.9874L74.1048 15.7993L11.3618 52.0458L74.1048 88.0427L136.848 51.9874Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9106 41.7314L100.883 49.8751V65.422L86.9106 57.4634V41.7314Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.586 54.3291L122.558 62.4729V78.0199L108.586 70.0612V54.3291Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomMeasurements);
export default __webpack_public_path__ + "static/media/room_measurements.b3074a220ecd0132d42248a0be24313d.svg";
export { ForwardRef as ReactComponent };